import { render, staticRenderFns } from "./ContentTable.vue?vue&type=template&id=1e4f7632&"
import script from "./ContentTable.vue?vue&type=script&lang=ts&"
export * from "./ContentTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports